import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=4f99971c&scoped=true&"
import script from "./DeleteItem.vue?vue&type=script&lang=js&"
export * from "./DeleteItem.vue?vue&type=script&lang=js&"
import style0 from "./DeleteItem.vue?vue&type=style&index=0&id=4f99971c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99971c",
  null
  
)

export default component.exports